<div class="widget-content">
  <div fxLayout="row" fxLayoutAlign="space-between center">
    <h2 class="title">
      Latest Form Submissions<span class="sub-title"> - Past 30 days</span>
    </h2>
    <item-picker
      [data]="itemPickerValues"
      [selectedValue]="selectedItemPickerValue"
      (select)="itemPickerSelect($event)"
      [smallSize]="true"
    ></item-picker>
  </div>
  @if (loaded) {
    @if (odataResult.length > 0) {
      <div class="items-container">
        <ng-scrollbar>
          @for (item of odataResult; track item.id) {
            <app-latest-form-submissions-item
              [item]="item"
            ></app-latest-form-submissions-item>
          }
        </ng-scrollbar>
      </div>
    } @else {
      <div class="no-content" fxLayout="column" fxLayoutAlign="center center">
        <p class="m-0">No form submissions in the past 30 days.</p>
      </div>
    }
  } @else {
    <div class="waiting-spinner">
      <mat-spinner strokeWidth="2" diameter="50"></mat-spinner>
      <p>Loading...</p>
    </div>
  }
</div>
